import { useDispatch } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H5 } from 'UIComponents/elements/headings';
import UILink from 'UIComponents/link/UILink';
import Categories from 'ContentUtils/constants/Categories';
import ContentRoutes from 'ContentUtils/Routes';

// @ts-expect-error Untyped module
import { closePatagoniaSidebar } from 'ContentEditorUI/redux/actions/panelActions';
import { Flex } from 'foundations-components/components/Flex';
import { CloseButton } from 'foundations-components/transitional/components/CloseButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const getContentDashboardLinkTextKey = categoryId => {
  switch (categoryId) {
    case Categories.blog_post.id:
      return 'contentManagementPanel.blogPostsDashboardLink';
    case Categories.blog_listing_page.id:
      return 'contentManagementPanel.blpDashboardLink';
    default:
      return 'contentManagementPanel.pagesDashboardLink';
  }
};
const ContentManagementSidebarHeader = ({
  contentTypeId
}) => {
  const dispatch = useDispatch();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      justifyContent: "space-between",
      paddingBlockStart: "200",
      paddingInlineEnd: "1100",
      paddingBlockEnd: "0",
      paddingInlineStart: "250",
      borderBlockEndStyle: "solid",
      borderBlockEndWidth: "100",
      borderBlockEndColor: "fill-primary-disabled",
      children: [/*#__PURE__*/_jsx(H5, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "contentManagementPanel.header"
        })
      }), /*#__PURE__*/_jsx(UILink, {
        external: true,
        href: ContentRoutes.dashboard(contentTypeId),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: getContentDashboardLinkTextKey(contentTypeId)
        })
      })]
    }), /*#__PURE__*/_jsx(CloseButton, {
      color: "icon-core-subtle",
      size: "medium",
      onClick: () => dispatch(closePatagoniaSidebar())
    })]
  });
};
export default ContentManagementSidebarHeader;